import styled, { css } from 'styled-components';
import { SectionHeading, Paragraph } from '../../global/typography';

export const StyledSection = styled.section`
    position: relative;
    display: flex;
    align-items: center;
    gap: 30px;
    padding: 3.12rem 0;

    @media (max-width: 979px) {
        flex-direction: column;
        gap: 15px;
    }
`;

export const StyledContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(12, 1fr);
`;

export const BannerContainer = styled.div`
    flex-direction: column;
    position: relative;
    padding: 50px 243px 50px 50px;
    height: 332px;
    box-sizing: border-box;
    grid-column: span 8;

    &:before {
        content: '';
        background-image: url('https://www.idosell.com/panel/file-gate.php?id=278958&ext=.jpeg');
        background-size: cover;
        background-position: center center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;

        @media (max-width: 757px) {
            background-image: url('https://www.idosell.com/panel/file-gate.php?id=286647&ext=.jpeg');
        }
    }

    @media (max-width: 979px) {
        flex: 0 0 100%;
        max-width: 100%;
        padding: 90px 35px 35px 35px;
        height: unset;
        grid-column: span 12;
    }
`;

export const StyledHeading = styled(SectionHeading)`
    color: white;
    text-align: left;
    margin-bottom: 0.94rem;

    @media (max-width: 757px) {
        font-size: 1.875rem;
        font-style: normal;
        font-weight: 600;
        line-height: 2.3125rem;
    }
`;

export const StyledParagraph = styled(Paragraph)`
    font-size: 18px;
    line-height: 27px;
    color: white;
`;

export const RightsideContainer = styled.div`
    display: grid;
    flex-direction: row;
    grid-template-columns: repeat(2, 1fr);

    @media (max-width: 979px) {
        grid-template-columns: repeat(4, 1fr);
    }

    @media (max-width: 757px) {
        grid-template-columns: repeat(2, 1fr);
        flex: 0 0 100%;
        max-width: 100%;
    }
`;

export const LogotypesContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
